<template>
	<div
		v-touch:tap="tapHandler"
		:class="containerClass"
		@keyup.enter="tapHandler"
		tabindex="0"
		role="link"
	>

		<template v-if="data">
			<div class="clearfix pt-3 pb-3">
				<div :class="getIconColor(file.asset_path)" style="float: left">
					<b-icon :icon="getFileIcon(file.asset_path)" />
				</div>
				<div style="float: left">
					<p class="font-bold mt-0 mb-0">{{ file.asset_title }}</p>
					<p class="text-xs mb-0 small">{{ getFileType(file.asset_path) }}</p>
				</div>
				<div  style="float: right">
					<button class="btn btn-sm btn-outline-primary mr-1" @click="toggleFavourite(file)">
						<b-icon :icon="file.is_favourite == 1 ? 'heart-fill' : 'heart'" />
					</button>
					<button class="btn btn-sm btn-outline-dark" @click="downloadFile(file)">
						<b-icon icon="download" />
					</button>
				</div>
			</div>
		</template>

		<template v-else>

			{{$t('loading')}}

		</template>

	</div>
</template>

<script>
export default {
	props: ['data', 'selectedItem'],
	computed: {
		file() {
			return this.data;
		},
		selected() {
			return this.selectedItem && this.selectedItem.asset_id == this.data.asset_id;
		},
		containerClass() {
			const classArr = [];
			if(this.selected) {
				classArr.push('active')
			}
			return classArr.join(' ');
		}
	},
	methods: {
		tapHandler() {
			if(this.data) {
				this.$emit('selectItem', this.data);
			}
		},
		getIconColor(fileName) {
			if(fileName) {
				const fileNameArr = fileName.split(".");

				if (fileNameArr[1].toLowerCase() === "pdf") {
					return "file-icon file-icon-pdf mr-2";
				}

				if (fileNameArr[1].toLowerCase() === "doc" || fileNameArr[1].toLowerCase() === "docx") {
					return "file-icon file-icon-word mr-2";
				}

				if (
					fileNameArr[1].toLowerCase() === "jpeg" ||
					fileNameArr[1].toLowerCase() === "jpg" ||
					fileNameArr[1].toLowerCase() === "gif" ||
					fileNameArr[1].toLowerCase() === "png"
				) {
					return "file-icon file-icon-image mr-2";
				}
			}

			return "file-icon file-icon-default mr-2";
		},
		getFileIcon(fileName) {
			if(fileName) {
				const fileNameArr = fileName.split(".");

				if (fileNameArr[1].toLowerCase() === "pdf") {
					return "file-earmark-richtext";
				}

				if (fileNameArr[1].toLowerCase() === "doc" || fileNameArr[1].toLowerCase() === "docx") {
					return "file-earmark-word";
				}

				if (
					fileNameArr[1].toLowerCase() === "jpeg" ||
					fileNameArr[1].toLowerCase() === "jpg" ||
					fileNameArr[1].toLowerCase() === "gif" ||
					fileNameArr[1].toLowerCase() === "png"
				) {
					return "file-earmark-image";
				}
			}

			return "file-earmark";
		},
		getFileType(fileName) {
			if(fileName) {
				const fileNameArr = fileName.split(".");

				if (fileNameArr[1].toLowerCase() === "pdf") {
					return this.$t('pdf');
				}

				if (fileNameArr[1].toLowerCase() === "doc" || fileNameArr[1].toLowerCase() === "docx") {
					return this.$t('word-document');
				}

				if (
					fileNameArr[1].toLowerCase() === "jpeg" ||
					fileNameArr[1].toLowerCase() === "jpg" ||
					fileNameArr[1].toLowerCase() === "gif" ||
					fileNameArr[1].toLowerCase() === "png"
				) {
					return this.$t('image');
				}
			}

			return this.$t('file');
		},
		toggleFavourite(file) {
			file.is_favourite = (file.is_favourite === "1" ? "0" : "1")
			this.$cfetch(`${this.$settings.APIBaseURL}/asset/favourite`, {
				method: "post",
				data: {
					asset_id: file.asset_id,
					favourite: file.is_favourite
				}
			});

		},
		downloadFile(file) {
			window.open(`${this.$settings.APIBaseURL}/asset/download/${file.asset_id}.${file.asset_extension}?username=${this.$UserSession.getValue.call(this, "username")}&authToken=${this.$UserSession.getValue.call(this, "authToken")}`);
		}
	}
};
</script>
